
import { Component, Prop, Vue } from "vue-property-decorator";
import { Reply } from "@/types/responseEntity";
import ReplyItem from "@/components/ReplyItem.vue";
@Component({
  components: { ReplyItem }
})
export default class ReplyBox extends Vue {
  @Prop(Array)
  public readonly replyList!: Reply[];
  protected render() {
    if (this.replyList.length > 0) {
      return (
        <div class="reply-box">
          <header>{this.replyList.length} 回复</header>
          <ul class="reply-list">
            {this.replyList.map((item, index) => {
              return <reply-item reply={item} index={index} />;
            })}
          </ul>
        </div>
      );
    }
  }
}
